export default ({ route, redirect }) => {
    const maintenanceMode = false;

    if (maintenanceMode && route.path !== '/maintenance/') {
        redirect('/maintenance')
    }
}